<template>
    <div id="diagnosis-report-download" class="diagnosis-report-download">
        <img src="../assets/images/diagnosis-report-logo.png" alt="" class="logo">
        <h1 class="title">{{ diagnosisResult.diagnosisName }}诊断结果</h1>
        <div class="content">
          <div class="content_center">
            <img src="../assets/images/diagnosis-report-avatar-default.png" alt="" class="avatar">
            <span class="name">{{ diagnosisResult.stuName }} ({{ diagnosisResult.stuUid }}) </span>
            <span class="score">{{ diagnosisResult.score }}</span>
            <span class="score_name">诊断得分</span>
            <div class="recommend">
              <span class="corner-left">推荐班型</span>
              {{ diagnosisResult.levelName || diagnosisResult.levelDegreeName || ''}}
            </div>
            <div class="sub-title">教师评语</div>
            <div class="teacher-word">
              {{ diagnosisResult.remark }}
            </div>
          </div>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    diagnosisResult: {
      type: Object,
      default: () => {}
    }
  }
}
</script>


<style lang="less" scoped>
.diagnosis-report-download {
  width: 520px;
  height: 912px;
  background-image: url('../assets/images/diagnosis-report-download-bg-1.png');
  background-repeat: no-repeat;
  line-height: 42px;
  position: fixed;
  left: -9999px;

  .logo{
    width: 95px;
    height: 19px;
    margin-top: 30px;
    margin-left: 40px;
  }
  .title {
    font-family: 'FZLanTingHeiS-B-GB';
    font-size: 30px;
    color: #5c2705;
    padding-left: 40px;
    padding-right: 100px;
    margin-bottom: 33px;
  }

  .content {
    width: 460px;
    height: 682px;
    background-image: url('../assets/images/diagnosis-report-download-bg-2.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-left: 26px;
    overflow: hidden;
    &_center {
      width: 364px;
      margin-top: 10px;
      margin-left: 53px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .avatar {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      background-color: #5c2705;
      margin-left: 10px;
      margin-top: 1px;
    }

    .name {
      margin-top: 24px;
      color: #5c2705;
      font-size: 12px;
      line-height: 1;
    }

    .score {
      margin-top: 24px;
      font-family: 'DIN Alternate';
      font-weight: 700;
      font-size: 40px;
      color: #f45d00;
    }

    .score_name {
      color: #666666;
      font-size: 12px;
      line-height: 2;
    }

    .recommend {
      margin-top: 42px;
      width: 100%;
      height: 100px;
      background-image: url('../assets/images/diagnosis-recommend-bg.png');
      background-size: 365px 101px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 24px;
      line-height: 28px;
      color: #3d3325;
      border: none;
      .corner-left {
        font-weight: normal;
        font-size: 12px;
        color: #fff;
        position: absolute;
        left: 0;
        top: -2px;
        line-height: 27px;
        padding-left: 8px;
      }
    }

    .sub-title {
      font-family: 'PingFang SC';
      width: 100%;
      color: #333333;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 1.8px;
      font-style: normal;
      font-weight: 500;
      margin-top: 40px;
      position: relative;
      &::before{
        content: '';
        position: absolute;
        left: -10px;
        top: -60%;
        background-image: url('../assets/images/diagnosis-exclamation-point.png');
        width: 42px;
        height: 30px;
      }
    }

    .teacher-word {
      width: 100%;
      text-align: left;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #565d66;
      margin-top: 12px;
    }
  }
}
</style>